/** Khớp với room backend `operation_staff` (utils/operationStaffSocket.js) */
export const OPERATION_STAFF_SOCKET_ROOM = "operation_staff";
